"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
      -------------------------------------------------------------------------------*/
			$dom: {
				accHead: $('.js-acc-item-head'),
				accContent: $('.js-acc-item-content')
			},

			classes: {
				active: 'is-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				$dom.accHead.on('click', function () {
					var $this = $(this);
					var currentContent = $this.siblings($dom.accContent);

					$dom.accContent.not(currentContent).slideUp();
					currentContent.slideToggle();

					$dom.accHead.not(this).removeClass(classes.active);
					$this.toggleClass(classes.active);

					// scroll to top of active accordion for mobile
					if (window.innerWidth < 768 && window.pageYOffset >= 600) {
						setTimeout(function () {
							var accTop = $this.offset().top - 70;
							$('html, body').animate({ scrollTop: accTop }, 300);
						}, 400);
					}
				});
			}
		};
	}, {}], 2: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				animateEl: $('.js-animate')
			},

			classes: {
				visible: 'is-visible'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				function animateInit() {
					var windowHeight = Global.$dom.window.height();
					var windowTopPosition = Global.$dom.window.scrollTop();
					var windowBottomPosition = windowTopPosition + windowHeight;

					if ($dom.animateEl.length && window.innerWidth > 767) {
						$dom.animateEl.each(function () {
							var $element = $(this);
							var animationDelay = $element.attr('data-delay');
							if (animationDelay === undefined) {
								animationDelay = 0;
							}

							var elementHeight = $element.outerHeight();
							var elementTopPosition = $element.offset().top;
							var elementBottomPosition = elementTopPosition + elementHeight;

							//check to see if this current container is within viewport
							if (elementBottomPosition >= windowTopPosition && elementTopPosition <= windowBottomPosition) {
								setTimeout(function () {
									$element.addClass(classes.visible);
								}, animationDelay);
							}

							// } else {
							// 	$element.removeClass(classes.visible);
							// }
						});
					}
				}

				animateInit();

				Global.$dom.window.on('scroll resize', function () {
					animateInit();
				});
			}

		};
	}, { "./global": 6 }], 3: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				button: $('.js-calc-btn'),
				resetButton: $('.js-calc-reset-btn'),
				calcForm: $('.js-calc-form'),
				calcResult: $('.js-calc-result'),
				total: $('.js-calc-result-total'),
				affiliate: $('.js-calc-result-affiliate'),
				fee: $('.js-calc-result-fee')
			},

			classes: {
				show: 'show-result',
				hide: 'hide-form'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// calculate
				$dom.button.on('click', function () {
					var average = $('.js-average').val();
					var commision = $('.js-commision').val();

					if (average.length > 0 && commision.length > 0 && $.isNumeric(average) && $.isNumeric(commision)) {
						// get vall from inputs
						var affiliateResult = average * commision / 100;
						var feeResult = affiliateResult * 20 / 100;

						$dom.total.text(affiliateResult + feeResult);
						$dom.affiliate.text(affiliateResult);
						$dom.fee.text(feeResult);
						$dom.calcForm.addClass(classes.hide);
						$dom.calcResult.addClass(classes.show);
					}
				});

				$dom.calcForm.find('input').keypress(function (e) {
					if (e.which == 13) {
						$dom.button.trigger('click');
					}
				});

				// reset calculator
				$dom.resetButton.on('click', function () {
					$dom.calcForm.find('input').val('');
					$dom.calcResult.removeClass(classes.show);
					$dom.calcForm.removeClass(classes.hide);
				});
			}
		};
	}, { "./global": 6 }], 4: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				counterMain: $('.js-counter')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var windowHeight = Global.$dom.window.height();

				function startCount(countSel) {
					if (countSel.length) {
						countSel.each(function () {
							var $this = $(this);

							$this.prop('counter', 0).animate({
								counter: $this.text()
							}, {
								duration: 2000,
								easing: 'swing',
								step: function step(el) {
									$this.text(Math.ceil(el));
								}
							});
						});
					}
				}

				$dom.counterMain.each(function () {
					var initCount = true;
					var $this = $(this);
					var countEl = $this.find('.js-count');

					Global.$dom.window.on('scroll resize', function () {
						var windowTop = Global.$dom.window.scrollTop();
						var windowBottom = windowTop + windowHeight;
						var elementTop = $this.offset().top + windowHeight / 5;

						if (elementTop <= windowBottom && initCount) {
							startCount(countEl);
							initCount = false;
						}
					});

					Global.$dom.window.trigger('scroll');
				});
			}
		};
	}, { "./global": 6 }], 5: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				ddSel: $('.js-dd-select'),
				ddCurrent: $('.js-dd-current'),
				ddOption: $('.js-dd-option'),
				ddInput: $('.js-dd-input')
			},

			classes: {
				open: 'is-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeDropdown() {
					$dom.ddSel.removeClass(classes.open);
				}

				// bind events
				$dom.ddCurrent.on('click', function (e) {
					e.stopPropagation();
					var $this = $(this);
					var $closestDD = $this.closest($dom.ddSel);
					$dom.ddSel.not($closestDD).removeClass(classes.open);
					$closestDD.toggleClass(classes.open);
				});

				$dom.ddOption.on('click', function () {
					var $this = $(this);
					var ddValue = $this.attr('data-dd-option');
					var ddText = $this.html();
					var $closestDD = $this.closest($dom.ddSel);
					$closestDD.find($dom.ddInput).val(ddValue);
					$closestDD.find($dom.ddCurrent).text(ddText);
					closeDropdown();
				});

				Global.functions.clickOutsideContainer(Global.$dom.body, $dom.ddSel, $dom.ddOption, closeDropdown);

				Global.functions.escKey(closeDropdown);
			}
		};
	}, { "./global": 6 }], 6: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $('body')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.stopPropagation();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 7: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open',
				noscroll: 'no-scroll'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.noscroll);
				}

				if (Global.vars.windowWidth < 768) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.noscroll);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 768) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				$dom.menuNav.on('click', 'a', function () {
					if (Global.vars.windowWidth < 768) {
						closeNav();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 6 }], 8: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				merchantsContainer: $('.js-merchants-container'),
				merchantItem: $('.js-merchant-item'),
				merchantNavItem: $('.js-merchant-item-nav')
			},

			classes: {
				hidden: 'is-hidden',
				visible: 'is-visible'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				var selectedMerchant = '';

				// functions
				function merchantsFilter() {
					$.ajax({
						url: share_sale_scripts.ajax_url,
						type: 'POST',
						data: {
							action: 'filter_merchants',
							term: selectedMerchant
						},
						success: function success(data) {
							$dom.merchantsContainer.addClass(classes.hidden).empty().html(data);
							var currentMerchantItems = $('.js-merchant-item');
							currentMerchantItems.each(function (i) {
								var $this = $(this);

								setTimeout(function () {
									$this.addClass(classes.visible);
								}, i * 100);
							});
						}
					});
					return false;
				}

				$dom.merchantNavItem.on('click', function () {
					selectedMerchant = $(this).data('slug');
					merchantsFilter();
				});
			}
		};
	}, {}], 9: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				parallax: $('.js-parallax')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				function parallax() {
					if ($dom.parallax.length && window.innerWidth > 767) {
						var sectionOffset = $dom.parallax.offset().top;
						var scrolled = Global.$dom.window.scrollTop() - sectionOffset;
						var sectionPosition = '50% ' + scrolled * 0.35;
						$dom.parallax.css('background-position', sectionPosition + 'px');
					}
				}

				parallax();

				Global.$dom.window.on('scroll', function () {
					parallax();
				});
			}
		};
	}, { "./global": 6 }], 10: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.js-slider'),
				sliderParent: $('.js-slider-parent'),
				brandSlider: $('.js-brand-slider'),
				ssSlider: $('.js-ss-slider'),
				msSlider: $('.js-ms-slider'),
				qSlider: $('.js-quest-slider'),
				dotSlider: $('.js-dot-slider'),
				unslick: $('.js-unslick'),
				arrowLeft: $('.arrow-left'),
				arrowRight: $('.arrow-right')
			},

			functions: {
				destroy: function destroy(callback) {
					$('.js-slider').slick('unslick');
				}
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var functions = this.functions;

				// brand slider
				$dom.brandSlider.each(function () {
					var $this = $(this);

					$this.slick({
						infinite: true,
						slidesToShow: 5,
						slidesToScroll: 5,
						dots: true,
						speed: 1000,
						arrows: false,
						autoplay: true,
						autoplaySpeed: 5000,
						responsive: [{
							breakpoint: 991,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 3
							}
						}]
					});
				});

				// single slide slider
				$dom.ssSlider.each(function () {
					var $this = $(this);

					$this.slick({
						infinite: true,
						fade: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						nextArrow: $this.parent($dom.sliderParent).find($dom.arrowRight),
						prevArrow: $this.parent($dom.sliderParent).find($dom.arrowLeft),
						speed: 1000
					});
				});

				// multiple items slider
				$dom.msSlider.each(function () {
					var $this = $(this);

					$this.slick({
						infinite: true,
						slidesToShow: 7,
						slidesToScroll: 1,
						nextArrow: $this.parent($dom.sliderParent).find($dom.arrowRight),
						prevArrow: $this.parent($dom.sliderParent).find($dom.arrowLeft),
						speed: 1000,
						responsive: [{
							breakpoint: 991,
							settings: {
								slidesToShow: 6
							}
						}, {
							breakpoint: 840,
							settings: {
								slidesToShow: 5
							}
						}]
					});
				});

				// question slider
				$dom.qSlider.each(function () {
					var $this = $(this);

					$this.slick({
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						nextArrow: $this.parent($dom.sliderParent).find($dom.arrowRight),
						prevArrow: $this.parent($dom.sliderParent).find($dom.arrowLeft)
					});
				});

				// dot slider
				$dom.dotSlider.each(function () {
					var $this = $(this);

					$this.slick({
						autoplay: true,
						autoplaySpeed: 4000,
						speed: 2000,
						infinite: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: true
					});
				});

				// unslick
				$dom.unslick.on('click', function () {
					functions.destroy();
					$(this).hide();
				});
			}
		};
	}, {}], 11: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				header: $('.site-header')
			},

			classes: {
				sticky: 'is-sticky',
				visible: 'is-visible',
				hidden: 'is-hidden'
			},

			vars: {
				headerOffsetHide: 100,
				headerOffsetStick: 200,
				headerOffsetShow: 500
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				var vars = this.vars;

				function stickyHeader() {
					if (window.pageYOffset >= vars.headerOffsetHide) {
						$dom.header.addClass(classes.hidden);
					} else {
						$dom.header.removeClass(classes.hidden);
					};

					if (window.pageYOffset >= vars.headerOffsetStick) {
						$dom.header.addClass(classes.sticky);
					} else {
						$dom.header.removeClass(classes.sticky);
					};

					if (window.pageYOffset >= vars.headerOffsetShow) {
						$dom.header.addClass(classes.visible);
					} else {
						$dom.header.removeClass(classes.visible);
					};
				}

				stickyHeader();

				Global.$dom.window.on('scroll', function () {
					stickyHeader();
				});
			}
		};
	}, { "./global": 6 }], 12: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		var Slider = require('./sliders');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
      -------------------------------------------------------------------------------*/
			$dom: {
				tabs: $('.js-tabs'),
				tabItem: $('.js-tab-item'),
				tabItemContent: $('.js-tab-item-content'),
				navItem: $('.main-navigation a')
			},

			classes: {
				active: 'is-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				$dom.tabItem.eq(0).addClass(classes.active);
				$dom.tabItemContent.eq(0).show();

				$dom.tabItem.each(function (index, el) {
					var $this = $(el);

					$this.on('click', function () {
						$this.addClass(classes.active);

						$dom.tabItem.not($this).removeClass(classes.active);

						var activeTabContent = $dom.tabItemContent.eq(index);
						activeTabContent.slideDown();
						$dom.tabItemContent.not(activeTabContent).slideUp();

						Slider.functions.destroy();
						Slider.init();
					});
				});

				// trigger tab click on for nav items and scroll to that tab
				function triggerTabClick() {
					setTimeout(function () {
						var hash = document.location.hash;

						if (hash) {
							var $tab = $("[data-tab='" + hash + "']");
							var tabTop = $tab.offset().top - 70;

							$tab.trigger('click');
							$('html, body').animate({ scrollTop: tabTop }, 600);
						}
					}, 400);
					//return false;
				}

				triggerTabClick();

				$dom.navItem.on('click', function (e) {
					triggerTabClick();
				});
			}
		};
	}, { "./global": 6, "./sliders": 10 }], 13: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			classes: {
				touch: 'is-touch'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				var classes = this.classes;

				function isTouch() {
					return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
				}

				if (isTouch()) {
					Global.$dom.body.addClass(classes.touch);
				}
			}
		};
	}, { "./global": 6 }], 14: [function (require, module, exports) {
		jQuery(function ($) {
			// Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			// Tabs
			var tabs = require('./_site/tabs');
			tabs.init();

			// Sticky Header
			var stickyHeader = require('./_site/stickyHeader');
			stickyHeader.init();

			// Parallax
			var parallax = require('./_site/parallax');
			parallax.init();

			// Animate Elements
			var animateOnScroll = require('./_site/animateOnScroll');
			animateOnScroll.init();

			// Dropdown
			var dropdown = require('./_site/dropdown');
			dropdown.init();

			// Accordion
			var accordion = require('./_site/accordion');
			accordion.init();

			// Merchants Filter
			var merchantsFilter = require('./_site/merchantsFilter');
			merchantsFilter.init();

			// Counter
			var counter = require('./_site/counter');
			counter.init();

			// Calculator
			var calculator = require('./_site/calculator');
			calculator.init();

			// Touch Detection
			var touchDetect = require('./_site/touchDetect');
			touchDetect.init();

			// Equal height
			// const equalHeight = require('./_site/equalHeight');
			// equalHeight.init();
		});
	}, { "./_site/accordion": 1, "./_site/animateOnScroll": 2, "./_site/calculator": 3, "./_site/counter": 4, "./_site/dropdown": 5, "./_site/menu": 7, "./_site/merchantsFilter": 8, "./_site/parallax": 9, "./_site/sliders": 10, "./_site/stickyHeader": 11, "./_site/tabs": 12, "./_site/touchDetect": 13 }] }, {}, [14]);